<template>
    <div
        :class="{ 'backgroundVisible': !el.photoCellImageIsEdited }"
        class="editorPhotoCellElement"
        :id="`editorPhotoCellElement-${el.id}`"
        :style="hasClipPath"
    >
        <PhotoCell 
            :el="el"
            :endValues="endValues"
            :transformDetails="transformDetails"
            :rotate="rotate"
            :parentFrame="parentFrame"
        />
        <div
            v-if="el.photoCellImageIsEdited"
            class="editorPhotoCellElement_after"
            :style="afterDivStyle"
        />
    </div>
</template>

<script>
    import PhotoCell from './photoCellTest.vue'
    import { mapGetters } from 'vuex';
    export default {
        data() {
            return {
                showClipPath: true
            }
        },
        computed: {
            hasClipPath() {
                if (this.el.photoCellImageIsEdited === false || this.el.isActive === false) {
                    return `clip-path:${this.el.path}; -webkit-clip-path:${this.el.path};`
                } else {
                    return null;
                }
                
            },
            afterDivStyle() {
                if ((this.el.photoCellImageIsEdited === false) || (this.el.isActive === false)) {
                    return 'display: none;';
                } else {
                    return `clip-path:${this.el.path}; -webkit-clip-path:${this.el.path}; display: block;`;
                }
            }
        },
        components: {
            PhotoCell
        },
        props: ['el', 'endValues', 'transformDetails', 'rotate', 'parentFrame']
    }
</script>

<style lang="scss" scoped>
    .editorPhotoCellElement {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .backgroundVisible {
        background-color: #8F6E9F;
        background-image: url(./../../../assets/icons/photo.svg);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 20%;
    }
    .photoCellImg {
        position: absolute;
    }
    .editorPhotoCellElement_after {
        background-color: white;
        opacity: 0.2;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        pointer-events: none;
    }
</style>